import React, {createRef} from 'react'
import { Translation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import Parent from '../../../common/parent';
import ReportsToolBar from "../reports_tool_bar/reportsToolBar";
import MonthsTable from "../table/monthsTable";
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import TablesLogic from "../table/tablesLogic";
import { constants } from "../../../common/constants/constants";
import i18n from "i18next";
import { createTotalRow } from '../../../common/utils/createTotalRows';

class YearlyCashFlowTable extends Parent {

    constructor(props) {
        super(props);
        this.printSectionRef = createRef();
        document.title = props.t('titles.cash_flow_report');

        this.state = TablesLogic.getInitialData();
        this.state.title = '';
        this.onYearChangedFunc = this.onYearChanged.bind(this);
        this.excelReportTitle.bind(this);
    }


    async componentDidMount(){
        this.genericBinds(this.props.history);
        await this.verifyLoggedIn();
        this.makeFullScreen();
        await this.loadYear(this.props.match.params.buildingID, this.props.match.params.year);
        this.bindTablesQuickSearch();
        const buildingData = await this.fetchBuildingData(this.props.match.params.buildingID);
        const totalRow = createTotalRow(this.state.rows, buildingData.currency);
        this.setState({
            ...this.state,
            rows: [...this.state.rows, totalRow]
        })
    }

    async onYearChanged(newYearSelected){
        BllinkLogger.info(`newYearSelected ${newYearSelected}`);
        // data-excel-title attribute is sticky without reloading tried for over 2 hours. fallback to page refresh
        // this.props.history.push(`/${constants.pages.yearlyCashFlowUrl}/${this.props.match.params.buildingID}/${newYearSelected}`)
        window.location.href = `/${constants.pages.yearlyCashFlowUrl}/${this.props.match.params.buildingID}/${newYearSelected}`
    }

    async loadYear(buildingID, year){
        this.startLoader();

        const excelReportTitle = await this.excelReportTitle(buildingID, year);
        const result = await this.fetchYearlyCashFlow(buildingID, year);
        if (result?.apartments) {
            let rows = result.apartments.rows;
            BllinkLogger.info(`loadYear rows are `, rows);
            rows = rows.sort((a, b) => {
                return parseInt(a.apartmentNumber) < parseInt(b.apartmentNumber) ? -1 : 1;
            })
            this.setState({
                loaded: true,
                rows: rows,
                currentYear: year,
                excelReportTitle: excelReportTitle
            })
        }

        this.bindTooltips();
        this.endLoader();
    }

    async excelReportTitle(buildingID, year){
        const title = await this.buildingTitleText(buildingID);
        this.setState({
            title
        });
        return title + ' - ' + year +  ' '+ i18n.t('reports.yearly_cashflow_title', { year: year ?? '' });
    }

    render() {
        const buildingID = this.props.match.params.buildingID;
        const year = this.props.match.params.year;
        this.setBodyClasses([constants.backgroundOptions.cashflow_yearly, constants.backgroundOptions.report]);
        const shouldLoadEmpty = (!this.state.userCheck || !this.state.loaded)
        if (shouldLoadEmpty){
            return (<div className="div-buffer-empty-content"/>)
        }

        BllinkLogger.info(`yearly cash this state `, this.state);

        return (
            <Translation>{(t, {_}) =>
                <section>
                    <h1 className='page-title'>
                        {this.state.title && (
                            <span className='building-title'>{this.state.title}</span>
                        )}
                    </h1>
                    <ReportsToolBar
                        options={this.state.yearsOptions}
                        onChange={this.onYearChangedFunc}
                        defaultValue={year}
                        pdfContainer={this.printSectionRef}
                        isTableEmpty={!this.state.rows.length}
                    />
                    <div id="section-to-print" ref={this.printSectionRef}>
                        <MonthsTable
                            title={t('reports.yearly_cashflow_title', {year: year ?? ''})}
                            rows={this.state.rows}
                            headerNames={this.state.headerNames}
                            tableType={"yearlyCashflow"}
                            excelReportTitle={this.state.excelReportTitle}
                            fields={this.state.rowsFields}
                            showExplanationSection={true}
                            buildingID={buildingID}
                            year={this.state.currentYear}
                        />
                    </div>
                </section>
            }</Translation>
        )
    }
}


export default withTranslation()(YearlyCashFlowTable)
